export function setDocumentTtitle(name: string) {
  document.title = `720漫游编辑-${name}`;
}
